import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-line",
  "use": "icon-nav-line-usage",
  "viewBox": "0 0 1 16",
  "content": "<symbol viewBox=\"0 0 1 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-nav-line\">\n<path d=\"M0.25 0V16\" stroke=\"#EEEEEE\" stroke-width=\"0.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol